import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

// import './polyfill'

import { createAxiosInstances } from 'statotest-api-requests/dist/helper';
import { statotestChartAppConfig } from 'statotest-charts';

import App from './App';
import { getBrand } from './branding/brands';
import { UnauthenticatedUserProvider } from './hooks/contexts/useUserDataContext';
import store from './store';

import appConfig from 'src/config.json';

import './helpers/dayjs-init';
import { featuresFlags } from './helpers/helpers';
import './i18n';
import { initSentry } from './utils/sentry';

export const API_DOMAIN = "api.statotest.com";

// Runtime branding podle domény: nastaví data-brand (barvy přes SCSS), title,
// favicon, meta tagy, theme-color a PWA manifest — vše z brand registry.
// Viz .context/dev/ADDING_A_BRAND.md.
/**
 * @param {string} name
 * @param {string} content
 */
const setMeta = (name, content) => {
  if (!content) { return; }
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const applyBrand = () => {
  const brand = getBrand();
  document.documentElement.dataset.brand = brand.id;
  document.title = brand.title;

  const favicon = document.querySelector("link[rel='shortcut icon'], link[rel='icon']");
  if (favicon) { favicon.setAttribute('href', brand.favicon); }

  const manifest = document.querySelector("link[rel='manifest']");
  if (manifest && brand.meta.manifest) { manifest.setAttribute('href', brand.meta.manifest); }

  setMeta('description', brand.meta.description);
  setMeta('keyword', brand.meta.keywords); // index.html historicky používá "keyword" (sg.)
  setMeta('author', brand.meta.author);
  setMeta('theme-color', brand.meta.themeColor);

  console.info('Active brand:', brand.id);
};

const init = () => {
  applyBrand();

  if (!import.meta.env.DEV) {
    // Initialize Sentry before anything else
    initSentry();
  } else { console.info("Sentry not initialized in development mode"); }

  createAxiosInstances({
    baseApiUrl: `https://${API_DOMAIN}`,
    inputApiUrl: appConfig.DIAPI_URL,
  });

  // init statotest-charts
  const appType = featuresFlags.params['statotest-charts'].appType;
  console.info("setting appType for statotest-charts: ", appType);
  statotestChartAppConfig.changeAppType(appType);
}
init();

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <UnauthenticatedUserProvider>
      <App />
    </UnauthenticatedUserProvider>
  </Provider>,
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.unregister();
